import { defineComponent as v, ref as a, getCurrentInstance as b, provide as h, reactive as y, toRefs as O, computed as g, onMounted as C, isVNode as E } from "vue";
import { useMutationObserver as _ } from "./index562.js";
import { selectGroupKey as x } from "./index676.js";
import { useNamespace as G } from "./index559.js";
import { isArray as N } from "./index575.js";
import T from "./index764.js";
var L = v({
  name: "ElOptionGroup",
  componentName: "ElOptionGroup",
  props: {
    /**
     * @description name of the group
     */
    label: String,
    /**
     * @description whether to disable all options in this group
     */
    disabled: Boolean
  },
  setup(m) {
    const c = G("select"), s = a(), l = b(), i = a([]);
    h(
      x,
      y({
        ...O(m)
      })
    );
    const f = g(
      () => i.value.some((t) => t.visible === !0)
    ), d = (t) => {
      var r;
      return t.type.name === "ElOption" && !!((r = t.component) != null && r.proxy);
    }, n = (t) => {
      const r = T(t), o = [];
      return r.forEach((e) => {
        var u;
        E(e) && (d(e) ? o.push(e.component.proxy) : N(e.children) && e.children.length ? o.push(...n(e.children)) : (u = e.component) != null && u.subTree && o.push(...n(e.component.subTree)));
      }), o;
    }, p = () => {
      i.value = n(l.subTree);
    };
    return C(() => {
      p();
    }), _(s, p, {
      attributes: !0,
      subtree: !0,
      childList: !0
    }), {
      groupRef: s,
      visible: f,
      ns: c
    };
  }
});
export {
  L as default
};
